var DKMS = window.DKMS || {};

DKMS.AddressUpdate = (function(){
    var f = function () {
        $('#addressUpdateForm').parsley();

        $('#addressUpdateForm input').on('blur', function () {
            $(this).parsley().validate();
        });

        $('.address_not_changed [type="checkbox"]').on('change', function(){
            var $this = $(this);
            var addressErrorField = $this.parents('ul:first').find('.address_error_field');

            if($this.is(':checked')){
                var elementsToHide = $this.parents('ul:first').find('li:not(.address_not_changed, .address_error_field)');
                elementsToHide.hide();
                elementsToHide.find('input,select').attr('disabled', 'disabled');    // commented out, interferes with #DEMAND-2899

                if(addressErrorField.hasClass('address-error-visible')){
                    addressErrorField.hide();
                }
            } else {
                var elementsToShow = $this.parents('ul:first').find('li:not(.address_not_changed, .address_error_field)');
                elementsToShow.show();
                elementsToShow.find('input,select').removeAttr('disabled');

                if(addressErrorField.hasClass('address-error-visible')){
                    addressErrorField.show();
                }
            }
        });

        $('.additional_address_fields [type="checkbox"]').on('change', function(){
            var $this = $(this);

            if($this.is(':checked')){
                $this.parents('ul:first').find('.new_apartment, .additional_address_info, .new_co_field').show();
            } else {
                $this.parents('ul:first').find('.new_apartment, .additional_address_info, .new_co_field').hide();
            }
        }).change();

        $('.lastname_changed [type="checkbox"]').on('change', function(){
            var $this = $(this);
            var lastnameWrapper = $('.new_lastname'),
                lastnameField = lastnameWrapper.find('input');

            if($this.is(':checked')){
                lastnameWrapper.show();
                lastnameField.removeAttr('disabled');
            } else {
                lastnameWrapper.hide();
                lastnameField.attr('disabled', 'disabled');
            }
        });

        window.parsley.on('form:validate', function () {
            var addressFields = ['.address input', '.new_address input'];

            for(var i in addressFields){
                var addressField = $(addressFields[i]);
                addressField.parents('.row:first').find('li.fieldwrapper').removeClass('hidden');
                addressField.parent().addClass('hidden');
            }
        });

        window.parsley.on('form:validate', function () {
            var addressFieldId = 'id_new_address',
                addressField = $('#' + addressFieldId);

            addressField.parents('.row:first').find('li.fieldwrapper').not('.new_address').removeClass('hidden');
            addressField.parent().addClass('hidden');
        });

    };
    return f;
})();

$(function () {
    if($('#addressUpdateForm').length == 1){
        new DKMS.AddressUpdate;
    }
});
